module.exports = __webpack_public_path__ + "c0aeecefd1ad15d5c5193d6f0849b7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email_attachement_2x.png
// module id = 14
// module chunks = 0 1 2 3 4